import "antd-mobile/bundle/style.css";
import "antd/dist/antd.min.css";
import { useEffect, useLayoutEffect } from "react";
import TagManager from "react-gtm-module";
import "./App.css";
import Context from "./context";
import "./plugins/i18n";
import RouterRender from "./router";

import { SnackbarProvider } from "notistack";
import { useTranslation } from "react-i18next";
import { httpClient } from "./apis/https";
import { envChangeType } from "./plugins/utils";

const currentTheme = require(`./theme/${process.env.REACT_APP_PRODUCTION_NAME_DEV}/theme.json`);
const defaultTheme = require(`./theme/defaultTheme.json`);
const finalTheme = { ...defaultTheme, ...currentTheme };
const initializedGtmIds = new Set();

const hasInjectedGtm = (gtmId) => {
  if (initializedGtmIds.has(gtmId)) return true;

  return Boolean(document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`));
};

function getFaviconEl() {
  return document.getElementById("favicon");
}
function getTitleEl() {
  return document.getElementById("head-title");
}

function App() {
  console.log("App render");
  const { t } = useTranslation();
  const setTheme = () => {
    const r = document.querySelector(":root");
    const final = Object.entries(finalTheme);
    final.map((color) => {
      r.style.setProperty(color[0], color[1]);
    });
  };
  useEffect(() => {
    setTheme();
  }, [finalTheme]);

  useLayoutEffect(() => {
    document.documentElement.setAttribute("data-prefers-color-scheme", "light");
  }, []);

  useEffect(() => {
    httpClient.translateFn = t;
  }, [t]);

  useEffect(() => {
    const favicon = getFaviconEl();
    const titleEl = getTitleEl();
    // console.log(favicon);
    favicon.href = `/images/versions/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/favicon.ico`;
    titleEl.innerHTML = envChangeType("REACT_APP_PRODUCTION_NAME_DISPLAY");

    setTimeout(() => {
      initStyle();
      initGTAG();
    }, 100);
  }, []);
  const initStyle = () => {
    let vh = window.innerHeight * 0.01;
    window.document.documentElement.style.setProperty("--vh", `${vh}px`);
    window.document.documentElement.style.setProperty("background", `#f5f5f5`);
  };

  const initGTAG = () => {
    const gcode = envChangeType("REACT_APP_GCODE");
    if (gcode === "" || gcode === null || gcode === undefined) return;
    gcode
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean)
      .forEach((gtmId) => {
        if (hasInjectedGtm(gtmId)) return;

        TagManager.initialize({
          gtmId,
        });
        initializedGtmIds.add(gtmId);
      });
  };

  //SCRIPT TO CHECK WHICH COMPONENT
  //BEING SCROLLED
  //USE ONLY WHEN DEBUG

  // window.addEventListener(
  //   "scroll",
  //   function (e) {
  //     var el = e.target;
  //     while (el && el !== document && !isScrollable(el)) {
  //       el = el.parent;
  //     }
  //     console.debug("Scrolled element: " + (el.className || "document"));
  //   },
  //   true
  // );

  // function isScrollable(el) {
  //   return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
  // }

  return (
    <div
      id="app"
      className="app"
      // style={{
      //   overflow: "visible",
      //   maxWidth: "450px",
      //   position: "relative",
      //   height: "calc(var(--vh, 1vh) * 100)",
      //   margin: "0 auto",
      // }}
    >
      <SnackbarProvider
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Context>
          <RouterRender />
        </Context>
      </SnackbarProvider>
    </div>
  );
}

export default App;
